import { render, staticRenderFns } from "./QuickQuotation.vue?vue&type=template&id=54f340ee&"
import script from "./QuickQuotation.vue?vue&type=script&lang=js&"
export * from "./QuickQuotation.vue?vue&type=script&lang=js&"
import style0 from "./QuickQuotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports